import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import axios from 'axios';
import { useAuth } from '../contexts/AuthContext';

const API = process.env.REACT_APP_BACKEND_URL;

const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { checkAuth } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      // Extract session_id from URL hash
      const hash = location.hash;
      const sessionIdMatch = hash.match(/session_id=([^&]+)/);
      
      if (!sessionIdMatch) {
        console.error('No session_id found in URL');
        navigate('/login', { replace: true });
        return;
      }

      const sessionId = sessionIdMatch[1];

      try {
        // Exchange session_id for session_token
        const response = await axios.post(
          `${API}/api/auth/session`,
          { session_id: sessionId },
          { withCredentials: true }
        );

        // Clear the URL hash
        window.history.replaceState(null, '', window.location.pathname);

        // Redirect to dashboard with user data
        navigate('/my-courses', { 
          replace: true,
          state: { user: response.data }
        });
      } catch (error) {
        console.error('Auth error:', error);
        navigate('/login', { replace: true });
      }
    };

    processAuth();
  }, [location.hash, navigate, checkAuth]);

  return (
    <div className="min-h-screen bg-kamit-cream flex items-center justify-center">
      <div className="text-center">
        <Loader2 className="h-12 w-12 text-kamit-gold animate-spin mx-auto mb-4" />
        <p className="text-kamit-brown text-lg">Connexion en cours...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
